export default __webpack_public_path__ + "static/media/theampitheatreofkarutonianormal.e61d3513.jpg";